import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Box, IconButton, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IWallet } from '@efex-services/client/types';
import { Currencies } from '@constants/enums';
import accountCreatedStyles from './AccountCreated.style';

import WalletCard from '../../../tabsWallets/WalletCard';
import { AccountCreatedProps } from './types/AccountCreated.types';

const AccountCreated = ({
  currencyName,
  newWalletData,
  addFunds,
  onConvert,
}: AccountCreatedProps) => {
  const { t } = useTranslation();

  const BUTTONS_DATA = [
    {
      title: t('addFunds', { currencyName }),
      text: t('addFundsDetails', { currencyName }),
      buttonAction: () => addFunds(newWalletData?.currency.name as Currencies),
    },
    {
      title: t('convertTitle', { currencyName }),
      text: t('convertDetails', { currencyName }),
      buttonAction: onConvert,
    },
  ];

  return (
    <Box className={accountCreatedStyles.container}>
      <Typography variant="h6" align="center">
        {t('accountCreatedTitle')}
      </Typography>

      <Typography variant="body2" align="center">
        {t('accountCreatedSubtitle', {
          currencyName,
        })}
      </Typography>

      <Box className={accountCreatedStyles.content}>
        <WalletCard wallet={newWalletData as IWallet} addFunds={() => {}} />

        <Typography variant="body2">
          {t('configureEnterpriseAccount')}
        </Typography>

        <Box>
          {BUTTONS_DATA.map((buttonData) => (
            <Box
              key={buttonData.title}
              className={accountCreatedStyles.buttonAction}
            >
              <Box>
                <Typography variant="body2">{buttonData.title}</Typography>
                <Typography variant="caption">{buttonData.text}</Typography>
              </Box>

              <IconButton onClick={buttonData.buttonAction}>
                <ArrowForwardIosIcon fontSize="small" />
              </IconButton>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default AccountCreated;
